import React from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
  current: PropTypes.object,
};

function QuestionInfo(props) {

    return (
        <React.Fragment>
            {props.current && props.current.question_data.requirement ? 
                (
                    <React.Fragment>
                    <span data-toggle="modal" data-target="#additionalInfoModal" className="text-center d-block textgreen mt-3 cur-p h-underline">{ __('app.questions.additional_question_info') }</span>
                    <div className="modal fade" id="additionalInfoModal" tabIndex="-1" role="dialog" aria-labelledby="additionalInfoModal" aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div className="modal-content p-3 p-sm-5">
                                <div className="modal-header">
                                    <h1 className="modal-title fw-600">
                                        { __('app.questions.additional_question_info_popup_title') }
                                    </h1>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div dangerouslySetInnerHTML={{__html: props.current.question_data.requirement.replace(/(<? *script)/gi, 'illegalscript')}}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </React.Fragment>
                ) : ('')
            }
        </React.Fragment>
    );
  
}

QuestionInfo.propTypes = propTypes;

export default QuestionInfo;